/* Plus Jakarta Sans 600. display 56/60 −0.025em · xl 32/38 −0.02em · lg 24/30 −0.015em · md 20/26 −0.01em · sm 18/24. */
.heading {
  margin: 0;
  font-family: var(--font-display);
  font-weight: var(--fw-semibold);
  color: var(--text-strong);
  letter-spacing: var(--ls-heading);
  line-height: var(--lh-snug);
  text-wrap: balance;
}
.heading[data-size="display"] {
  font-size: var(--fs-display);
  letter-spacing: var(--ls-display);
  line-height: var(--lh-tight);
  text-wrap: pretty;
}
.heading[data-size="xl"] {
  font-size: var(--fs-4xl);
}
.heading[data-size="lg"] {
  font-size: var(--fs-2xl);
  letter-spacing: var(--ls-subheading);
  line-height: 1.25;
}
.heading[data-size="md"] {
  font-size: var(--fs-xl);
  letter-spacing: -0.01em;
  line-height: 1.3;
}
.heading[data-size="sm"] {
  font-size: var(--fs-lg);
  letter-spacing: 0;
  line-height: var(--lh-normal);
}
